/**
 * React component that renders a cover image for Airbnb cards
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Yucho Ho
 */
import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import CoverImage from 'client/shared/js/components/CoverImage'
import styles from './AirbnbCoverImage.module.scss'

const AirbnbCoverImage = ({ data }) => {
  const { imgUri } = data

  const background = useMemo(() => {
    if (imgUri) {
      return (
        <CoverImage photoUrl={imgUri} />
      )
    } else {
      // TODO: Create and replace below with a new image for airbnb
      return (
        <div className={cx(styles['illustration-bg'])}>
          <img src='/static/assets/img/illustrations/through-park.svg' className={cx([styles['illustration']])} />
        </div>
      )
    }
  }, [imgUri])

  return background
}

AirbnbCoverImage.propTypes = {
  data: PropTypes.object
}

export default AirbnbCoverImage
